import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import LoginPage from './Pages/Admin/LoginPage';
import SignupPage from './Pages/Admin/SignupPage';
import SideNav from './Components/Admin/SideNav';
import DashboardContent from './Components/Admin/DashboardContent';
import BasisCosting from './Components/Admin/BasisCosting';
import { useAuth } from './Contexts/AuthContext';
import ForgotPasswordPage from './Pages/Admin/ForgotPassword';
import ApplicationForm from './Components/Admin/ApplicationForm';
import EmailVerification from './Pages/Admin/EmailVerification';
import Users from './Components/Admin/Users';
import Submissions from './Components/Admin/Submissions';
import AdminDashboard from './Components/Admin/AdminDashboard';

import Support from './Components/Admin/Support';
import FileViewer from './Components/Admin/FileViewer';
import DepartmentReport from './Components/Admin/DepartmentReport';
import OfficesDepartments from './Components/OfficesDepartments';
import Calculator from './Components/Admin/Calculator';
import ValueChainEditor from './Components/Admin/ValueChainEditor';
import KibaloContent from './Components/Admin/ValueChainContent';
import ValueChainEditorDetails from './Components/Admin/ValueChainEditorDetails';
import EquipmentCosts from './Components/Admin/EquipmentCosts';
import UnitPage from './Components/Admin/UnitPage'; // ✅ NEW IMPORT
import EnterpriseAnalysis from './Components/Admin/EnterpriseAnalysis';
import EstablishmentCosts from './Components/Admin/EstablishmentCosts';
import InterestPage from './Components/Admin/InterestPage';
import MaintenancePage from './Components/Admin/MaintenancePage';
import VariableCosts from './Components/Admin/VariableCosts';
import GlobalMarketValue from './Components/Admin/GlobalMarketValue';
import SummaryPage from './Components/Admin/SummaryPage'; // Import the new Summary Page

import { auth, db } from './Services/firebase-config';


function App() {
  return (
    <Router>
      <Routes>
        {/* Authentication Routes */}
        <Route
          path="/login"
          element={
            <AuthRoute>
              <LoginPage />
            </AuthRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <AuthRoute>
              <ForgotPasswordPage />
            </AuthRoute>
          }
        />
        <Route
          path="/register"
          element={
            <AuthRoute>
              <SignupPage />
            </AuthRoute>
          }
        />
        <Route
          path="/verify-email"
          element={
            <AuthRoute>
              <EmailVerification />
            </AuthRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <SideNav>
                <Routes>
                  <Route index element={<DashboardContent />} />
                  <Route path="application-form" element={<ApplicationForm />} />
                  <Route path="/update-application/:id" element={<ApplicationForm updateMode={true} />} />
                  <Route path="/department-report" element={<DepartmentReport />} />
                  <Route path="/file-viewer" element={<FileViewer />} />
                  <Route path="/calculator" element={<Calculator />} />
                  <Route path="/enterprise-analysis" element={<EnterpriseAnalysis />} />
                  <Route path="/calculator/:kibaloId" element={<KibaloContent />} />
                  <Route path="/basic-costing/:kibaloId" element={<BasisCosting />} />
                  <Route path="/establishment-costing/:kibaloId" element={<EstablishmentCosts />} />
                  <Route path="/equipment-costing/:kibaloId" element={<EquipmentCosts />} />
                  <Route path="/maintenance-costing/:kibaloId" element={<MaintenancePage />} />
                  <Route path="/interest-costing/:kibaloId" element={<InterestPage />} />
                  <Route path="/variable-costing/:kibaloId" element={<VariableCosts />} />
                  <Route path="/global-market-value" element={<GlobalMarketValue />} />
                  <Route path="/cost-breakdown/:kibaloId" element={<UnitPage />} />
                  <Route path="/summary/:kibaloId" element={<SummaryPage />} />
                
                  <Route path="/calculator/:valueChainId/details" element={<ValueChainEditorDetails />} />
                  <Route path="/calculator/:valueChainId/activities" element={<EquipmentCosts />} />
                  <Route path="/calculator/:kibaloId/UnitPage" element={<UnitPage />} />
                  <Route path="/calculator/:valueChainId/maintenance" element={<MaintenancePage />} />
                  <Route path="/kibalo/:kibaloId" element={<KibaloContent />} />
                  <Route path="/dashboard/:valueChainId/:selectedProductId" element={<DashboardContent />} />
                  <Route path="users" element={<Users />} />
                  <Route path="OfficesDepartments" element={<OfficesDepartments />} />
                  <Route path="adminsdashboard" element={<AdminDashboard />} />
                  <Route path="support" element={<Support />} />
                </Routes>
              </SideNav>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/register" />;
  }
  if (currentUser && !currentUser.emailVerified) {
    return <Navigate to="/verify-email" />;
  }

  return children;
};

const AuthRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (currentUser && currentUser.emailVerified) {
    return <Navigate to="/" />;
  }

  return children;
};

export default App;
